type LegacyRedirectSurface = "directory" | "calendar";

export function buildLegacyEventUrl(
  surface: LegacyRedirectSurface,
  legacyCourseId: number | null | undefined,
): string {
  const base = import.meta.env.VITE_MEMBER_PORTAL_URL ?? "";

  if (legacyCourseId != null) {
    return `${base}/Course/Course/CourseOverview?CourseId=${legacyCourseId}`;
  }

  return surface === "calendar"
    ? `${base}/Course/Course/Calendar`
    : `${base}/Course/Course/CourseCatalog`;
}
